<template>
  <component
    :is="TableControlTypeConst[itemSchema.displayType.toLowerCase()]"
    :class="{
      [$style.controlContainer] : true,
      [$style.fixedSize]: useFixedSize
    }"
    :control="itemSchema"
    :handleValueChange="handleValueChange"
    :onlyBreakAtNewlines="true"
    :resizeable="true"
    :smallInput="true"
    :value="findControlValue(itemSchema.name)"
  />
</template>
<script>
import { TableControlTypeConst } from 'client/components/DynamicControls/constants/DynamicControlsConstants';
import DynamicControlsCheckbox from 'client/components/DynamicControls/BodyComponents/DynamicControlsCheckbox';
import DynamicControlsComboBox from 'client/components/DynamicControls/BodyComponents/DynamicControlsComboBox';
import DynamicControlsDropDown from 'client/components/DynamicControls/BodyComponents/DynamicControlsDropDown';
import DynamicControlsFileInput from 'client/components/DynamicControls/BodyComponents/DynamicControlsFileInput';
import DynamicControlsInput from 'client/components/DynamicControls/BodyComponents/DynamicControlsInput';
import DynamicControlsSpinnerInput
  from 'client/components/DynamicControls/BodyComponents/DynamicControlsSpinnerInput';
import DynamicControlsTextarea from 'client/components/DynamicControls/BodyComponents/DynamicControlsTextarea';

export default {
  name: 'TableDynamicFields',

  components: {
    DynamicControlsCheckbox,
    DynamicControlsComboBox,
    DynamicControlsDropDown,
    DynamicControlsInput,
    DynamicControlsSpinnerInput,
    DynamicControlsTextarea,
    DynamicControlsFileInput,
  },

  inject: ['$validator'],

  props: {
    index: {
      type: Number,
      default: undefined,
    },
    itemSchema: {
      type: Object,
      required: true,
    },
    rowItem: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      TableControlTypeConst,
    };
  },

  computed: {
    useFixedSize() {
      return this.itemSchema.displayType.toLowerCase() === 'select';
    },
  },

  methods: {

    findControlValue(controlName) {
      return this.rowItem[controlName];
    },

    handleValueChange(control, value) {
      this.rowItem[this.itemSchema.name] = value;
      this.$emit('fieldChange', this.index, this.rowItem);
      return { control, value };
    },
  },
};
</script>
<style module scoped>

.controlContainer {
  padding-right: 10px;
}

.fixedSize {
  max-width: 140px;
  min-width: 100px;
}

</style>
